<template>
  <footer class="landing__footer">
    <b-container>
      <b-row>
        <b-col sm="6" class="text-center text-sm-left">
          <img
            class="landing__footer__logo"
            src="@/assets/img/logo/logo_original.png"
            alt="Boxx Barber Shop logo"
          />
        </b-col>
        <b-col sm="6">
          <b-row>
            <b-col lg="6" class="mt-4 mt-sm-0">
              <div>
                <a
                  class="landing__footer__social"
                  href="https://www.instagram.com/boxxbarbershop/"
                  target="_blank"
                  ><i class="fa fa-instagram"></i
                ></a>
                <a
                  class="landing__footer__social"
                  href="https://www.facebook.com/Boxx/?fref=ts"
                  target="_blank"
                  ><i class="fa fa-facebook"></i
                ></a>
              </div>
              <a
                class="landing__footer__link"
                href="mailto:info@boxx.ie"
                target="_blank"
                >info@boxx.ie</a
              >
              <router-link class="landing__footer__link" to="/privacy-policy"
                >Privacy Policy</router-link
              >
              <router-link
                class="landing__footer__link"
                to="/terms-and-conditions"
                >Terms & Conditions</router-link
              >
            </b-col>
            <b-col lg="6" class="mt-4 mt-lg-0">
              <p class="landing__footer__poweredBy landing__footer__link">
                Powered by
                <strong>
                  <a href="https://www.smartbooks365.com" target="_blank"
                    >Smartbooks</a
                  >
                </strong>
              </p>
              <p class="landing__footer__copyright">
                © {{ year }} <strong>BOXX Barber Shop</strong>
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>
<script>
import moment from 'moment';
export default {
  data() {
    return {
      year: moment().format('YYYY')
    };
  }
};
</script>
